module.exports = __webpack_public_path__ + "static/media/icon_event_in_draw.98e55199.svg";